import { FunctionComponent, lazy } from 'react'

const InsuranceContainer = lazy(() => import('./InsuranceContainer'))

const InsuranceLazyContainer: FunctionComponent = () => <InsuranceContainer />

export default InsuranceLazyContainer
